import { PickupSlot } from '@/types';

// v2-task-P1 (backend-accuracy fix): a CLIENT-SIDE, DISPLAY-ONLY mirror of
// T3's backend auto-advance intent — "the soonest slot whose window has not
// passed yet". This used to re-derive "not yet passed" from the browser's
// wall clock, which disagreed with the backend near the Asia/Baghdad 04:00
// operational-day cutover (PickUpSlotController::index →
// OperationalDayService::hasWindowPassed). The server already computes
// `is_next_day` per slot with that exact Baghdad/op-day/cutoff logic, so the
// preview now just trusts it: the first slot (in the server's returned
// order — already ordered by code/window, never re-sorted here) with
// `is_next_day === false` is exactly the slot auto-select could still book
// today. No clock, browser or otherwise, is involved.
export const getWouldPickSlot = (slots: PickupSlot[]): PickupSlot | null => {
  return slots.find((slot) => !slot.is_next_day) ?? null;
};
